module.exports = __webpack_public_path__ + "img/emoji-worried.35d9284c.png";